<template>
  <b-container fluid>
    <div class="alarm-configurations">
      <alarms-filter
        class="mb-4"
        @search="setFiltersAndSearch"
      />
      <alarms-configurations-list
        :alarms-list="alarmsList"
        :loading="loading"
        :pagination="pagination"
        :filter="latestFilter"
        :filtered-assets-total="filteredAssetsTotal"
        :edit-alarm-callback="callUpdateAlarmClassification"
        @search:alarmName="setFiltersAndSearch"
        @paginate="searchAlarms"
      />
    </div>
  </b-container>
</template>
<script>
import AlarmConfigurationsService
  from '@/domain/services/generalPanel/adminPanel/alarmConfigurations';
import AlarmsConfigurationsList
  from '@/domain/components/generalPanel/adminPanel/alarmConfigurations/AlarmsConfigurationList';
import AlarmsFilter from '@/domain/components/generalPanel/adminPanel/alarmConfigurations/Filters';
import GlobalUserService from '@/services/user';

export default {
  name: 'AlarmConfigurations',
  components: {
    AlarmsFilter,
    AlarmsConfigurationsList,
  },
  data: () => ({
    latestFilter: {},
    loading: 0,
    alarmsList: [],
    pagination: {
      perPage: 100,
      currentPage: 1,
      totalRows: null,
    },
    filteredAssetsTotal: 0,
  }),
  created() {
    GlobalUserService.validateUserPermission('PER004');
    this.searchAlarms();
  },
  methods: {
    callUpdateAlarmClassification(options) {
      this.loading += 1;
      const payload = {
        ...this.latestFilter,
        ...options,
      };
      return AlarmConfigurationsService
        .updateAlarmClassification(payload)
        .then(() => {
          this.$pushAlert({ code: 'MS006' });
          this.searchAlarms(this.latestFilter);
        })
        .finally(() => {
          this.loading -= 1;
        });
    },
    setPaginationPage(pageNumber) {
      this.$set(this.pagination, 'currentPage', pageNumber);
    },
    setFiltersAndSearch(filters) {
      this.latestFilter = {
        ...this.latestFilter,
        ...filters,
      };
      this.filteredAssetsTotal = 0;
      this.setPaginationPage(1);
      this.searchAlarms();
      this.getFilteredAssetsTotal();
    },
    searchAlarms() {
      const { perPage, currentPage } = this.pagination;
      const payload = {
        pageSize: perPage,
        page: currentPage,
        ...this.latestFilter,
      };

      this.loading = true;

      AlarmConfigurationsService
        .getAlarmsList(payload)
        .then((response) => {
          this.alarmsList = response.data;
          this.pagination.totalRows = response.total;

          if (!(this.alarmsList || []).length) {
            this.$pushAlert({
              code: 'MA009',
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFilteredAssetsTotal() {
      const { currentPage } = this.pagination;
      const payload = {
        pageSize: 15,
        page: currentPage,
        ...this.latestFilter,
      };
      AlarmConfigurationsService.getAlarmAssets(payload)
        .then((data) => {
          this.assetsInvolved = (data.data || []).map(item => item.assetId);
          if (!(this.latestFilter.companiesIds || []).length) {
            this.filteredAssetsTotal = 0;
            return;
          }
          this.filteredAssetsTotal = data.total || 0;
        });
    },
  },
};
</script>
